import { useLang } from 'hooks/lang';

import { actions, canCancelInvoiceControl, invoiceControlStatusConfig } from 'entities';

import { Column, Dot, DropdownMenuItem, Row } from 'components/Blocks';
import { CircleXIcon } from 'components/Icons';

import { useUser } from 'hooks';
import { useProjectProfile } from 'pages/Projects/ProjectProfile/context';
import { useSingleJustification } from 'providers/Justification';
import { useConfirmation } from 'providers/Confirmation';

export function CancelProjectInvoiceOption() {
  const { t } = useLang();
  const user = useUser();

  const { project, updateProject } = useProjectProfile();

  const { requestConfirmation } = useConfirmation();

  const cancel = actions.invoice.requestInvoiceControlCancelation.use({
    onSuccess: () => {
      updateProject((old) => ({
        ...old,
        invoice: {
          ...old.invoice,
          status: invoiceControlStatusConfig.pendingApproval.code,
        },
      }));
    },
  });

  const openJustification = useSingleJustification({
    title: t('cancel-invoicing-for-project?')!,

    text: (
      <Column gap="1" className="pl-1 text-sm">
        <Row gap="2">
          <Dot color="primary" size={4} />
          {t('request-will-go-to-sales')}
        </Row>

        <Row gap="2">
          <Dot color="primary" size={4} />
          {t('no-action-until-answer')}
        </Row>

        <Row gap="2" className="font-medium">
          <Dot color="primary" size={4} />
          {t('cancel-is-final')}
        </Row>
      </Column>
    ),

    onConfirm: (justification) =>
      requestConfirmation({
        type: 'irreversible',

        onConfirm: async () =>
          cancel.execute({
            justification,
            projectId: project.id,
          }),
      }),
  });

  if (!canCancelInvoiceControl(project, user)) return null;

  return (
    <DropdownMenuItem onClick={openJustification}>
      <CircleXIcon />
      {t('cancel')}
    </DropdownMenuItem>
  );
}
